// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__lmq3g","title":"Images90_title__2v2cc","images":"Images90_images__1yVQo"};